export default __webpack_public_path__ + "static/media/CIA-Fidelity-Computer-Crime-Claim-Form.2d7ed9c9.pdf";